import { pathgen } from 'object-path-generator';
export const FeedbackModalTestIds = pathgen('FeedbackModalTestIds');
